import { Config } from 'models';

const staticPath = `${process.env.PUBLIC_URL}/static`;

const getFile = async (url) => (await fetch(url)).json();

const set = (key, value = {}) => window.localStorage.setItem(key, JSON.stringify(value));

const get = (key) => JSON.parse(window.localStorage.getItem(key) || '{}');

const inject = async () => {
  const configApis = await getFile(`${staticPath}/configs/config.json`);
  set('ionosConfig', configApis);

  return true;
};

const getConfig = () => new Config(get('ionosConfig'));

const setConfig = (configObj) => {
  const config = new Config(get('ionosConfig'));
  if (typeof configObj === 'string') {
    try {
      configObj = JSON.parse(configObj);
    } catch (e) {
      configObj = {};
    }
  }

  const mergedConfig = Object.keys(configObj).reduce((acc, key) => {
    if (Array.isArray(acc[key]) && Array.isArray(configObj[key])) {
      acc[key] = [...acc[key], configObj[key]];
    } else if (typeof acc[key] === 'object' && typeof configObj[key] === 'object') {
      acc[key] = { ...acc[key], ...configObj[key] };
    } else {
      acc[key] = configObj[key];
    }

    return acc;
  }, config);

  set('ionosConfig', mergedConfig);
};

export {
  inject,
  staticPath,
  getConfig,
  setConfig,
};
